import { gql } from "@apollo/client";

export const ADD_DOCUMENTO_PROFESIONAL = gql`
  mutation AddDocumentoProfesional(
    $input: AddDocumentoProfesionalInput!
    $idProfesional: Int!
    $idTipoDocumento: Int!
  ) {
    addDocumentoProfesional(
      input: $input
      idProfesional: $idProfesional
      idTipoDocumento: $idTipoDocumento
    ) {
      success
    }
  }
`;

export const DELETE_DOCUMENTOS_PROFESIONAL = gql`
  mutation DeleteDocumentosProfesional(
    $idTipoDocumento: Int!
    $idProfesional: Int!
  ) {
    deleteDocumentosProfesional(
      idTipoDocumento: $idTipoDocumento
      idProfesional: $idProfesional
    ) {
      success
    }
  }
`;

export const ADD_SEGURO_MALA_PRAXIS = gql`
  mutation AddSeguroMalaPraxis(
    $input: AddSeguroMalaPraxisInput!
    $idProfesional: Int!
  ) {
    addSeguroMalaPraxis(
      input: $input
      idProfesional: $idProfesional
    ) {
      success
    }
  }
`;

export const DELETE_SEGURO_MALA_PRAXIS = gql`
  mutation DeleteSeguroMalaPraxis($idArchivo: Int!) {
    deleteSeguroMalaPraxis(idArchivo: $idArchivo) {
      success
    }
  }
`;